import { useContext } from 'react';
import { IModalContext } from '../Types/Modal/Modal.type';
import { ModalContext } from '../Contexts/Modal/Modal.context';

export const useModal = (): IModalContext => {
    const context = useContext(ModalContext);
    if(!context) {
        throw new Error("useModal deve ser usado dentro do ModalProvider");
    }

    return context;
};